const ADD_GBIFI_TOKEN = '0x22F68ae048B126ad76cd5dbc2c671603a188D6dc';
const ADD_BIFI_TOKEN = '0x2791bfd60d232150bff86b39b7146c0eaaa2ba81';

export { ADD_GBIFI_TOKEN, ADD_BIFI_TOKEN };
